import { useQuery } from "src/Hooks/useReactQuery";
import { getSimulatorOptions } from "src/services/simulator-flight"; 

const useVersion = (
  simulationType = "",
) => {
  const { data, isLoading, isError, error } = useQuery(
    ["getVersionOptions", simulationType],
    () => getSimulatorOptions(simulationType),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: 0,
      retry: 0,
      networkMode: "always",
    },
  );

  return { 
    data,
    isLoading, 
    isError, 
    error, 
    options: data?.map(item => {
      return {
        label: item.name,
        value: item.name,
      };
    }) || []
  };
};

export default useVersion;